import React, { useState } from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';

interface Service {
  title: string;
  description: string;
  details: string;
  link?: string;
}

const Services: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<number | null>(0); // Default to first category
  const [flippedCards, setFlippedCards] = useState<number[]>([]);

  const navigate = useNavigate();
  const handleCardFlip = (index: number) => {
    if (flippedCards.includes(index)) {
      setFlippedCards(flippedCards.filter(i => i !== index));
    } else {
      setFlippedCards([...flippedCards, index]);
    }
  };
  const serviceCategories: { category: string; services: Service[] }[] = [
    {
      category: 'Websites',
      services: [
        { title: 'Website Development', description: 'Custom websites for small businesses and local brands.', details: 'SEO-friendly websites, landing pages, content pages, forms, analytics, hosting guidance, and business integrations.' },
        { title: 'Ecommerce Sites', description: 'Online storefronts and product pages.', details: 'Shop pages, checkout flows, product detail pages, shipping logic, payment integrations, and custom ordering experiences.' },
        { title: 'Website Refreshes', description: 'Modernize an existing website.', details: 'Improve layout, mobile behavior, messaging, speed, accessibility, and conversion paths without starting from zero.' },
      ],
    },
    {
      category: 'Apps',
      services: [
        { title: 'Custom App Development', description: 'Business tools built around your workflow.', details: 'Dashboards, internal tools, customer portals, mobile-friendly apps, admin panels, and custom software for day-to-day operations.' },
        { title: 'Cloud Applications', description: 'Scalable app architecture and deployment.', details: 'AWS, Azure, and GCP application design with APIs, databases, authentication, storage, monitoring, and cost-aware operations.' },
        { title: 'AI and Automation', description: 'Smarter workflows and business integrations.', details: 'Chatbots, RAG solutions, AI-assisted workflows, data integrations, and practical automations for repetitive business tasks.' },
      ],
    },
    {
      category: '3D Printing',
      services: [
        { title: 'Custom 3D Prints', description: 'Personalized gifts and product ideas.', details: 'Custom 3D printed magnets, jewelry, decorations, party favors, signs, keepsakes, and small-batch creative products.' },
        { title: 'Prototypes', description: 'Turn early ideas into physical models.', details: 'Simple prototypes, concept models, fit checks, samples, and iteration support for makers, students, and small businesses.' },
        { title: 'Local Product Design', description: 'Design help for custom printed items.', details: 'Support for product concepts, personalization, printability, sizing, materials, and preparing ideas for production.' },
      ],
    },
  ];

  return (
    <div className="services-container">
      <section className="services-intro">
        <h1>Hogcloud Services</h1>
        <p>
          Hogcloud provides website development, custom app development, cloud
          software, AI automation, and custom 3D printing for small businesses,
          creators, families, and local organizations.
        </p>
      </section>

      <div className="category-buttons">
        {serviceCategories.map((category, index) => (
          <button
            key={index}
            className={`category-button ${activeCategory === index ? 'active' : ''}`}
            onClick={() => setActiveCategory(index)}
          >
            {category.category}
          </button>
        ))}
      </div>

      <div className="service-cards">
        {serviceCategories[activeCategory!].services.map((service, index) => (
          <div key={index} className={`service-card ${flippedCards.includes(index) ? 'flipped' : ''}`} onClick={() => handleCardFlip(index)}>
            <div className="card-inner">
              <div className="card-front">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
              <div className="card-back">
                <p>{service.details} 
                <button onClick={() => navigate('/contact')}>Learn More</button>

                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
